(function () {
  'use strict';

  var BADGE_CLASS = 'bundly-promo-badge';
  var HOST_CLASS = 'bundly-promo-badge-host';
  var BADGE_ATTR = 'data-bundly-promo-badge';
  var RETRY_DELAYS = [0, 300, 800, 1500];
  var observerStarted = false;

  function readFallbackText() {
    var el = document.getElementById('bundly-promo-fallback');
    if (!el) return '';

    try {
      var value = JSON.parse(el.textContent || '""');
      if (value == null) return '';
      return String(value).replace(/<[^>]*>/g, '').trim();
    } catch (e) {
      return (el.textContent || '').trim();
    }
  }

  function parseMoney(text) {
    if (!text) return null;

    var normalized = String(text)
      .replace(/\s/g, '')
      .replace(/[^\d,.-]/g, '');

    if (!normalized) return null;

    var lastComma = normalized.lastIndexOf(',');
    var lastDot = normalized.lastIndexOf('.');

    if (lastComma > -1 && lastDot > -1) {
      if (lastComma > lastDot) {
        normalized = normalized.replace(/\./g, '').replace(',', '.');
      } else {
        normalized = normalized.replace(/,/g, '');
      }
    } else if (lastComma > -1) {
      var afterComma = normalized.length - lastComma - 1;
      normalized = afterComma === 2
        ? normalized.replace(',', '.')
        : normalized.replace(/,/g, '');
    }

    var amount = parseFloat(normalized);
    return isNaN(amount) ? null : amount;
  }

  function findBlocks() {
    return Array.prototype.slice.call(document.querySelectorAll('.bundly__block'));
  }

  function findComparePriceEl(block) {
    return (
      block.querySelector('.bundly__bundle_original_price') ||
      block.querySelector('s[class*="original"]') ||
      block.querySelector('[class*="bundle_original_price"]') ||
      block.querySelector('s') ||
      block.querySelector('[class*="compare"]') ||
      block.querySelector('[class*="original"]')
    );
  }

  function findFinalPriceEl(block, compareEl) {
    var exact = block.querySelector('.bundly__bundle_new_price');
    if (exact && exact !== compareEl) return exact;

    var candidates = block.querySelectorAll(
      '.bundly__bundle_new_price, [class*="bundle_new_price"], [class*="new-price"], [class*="final"], [class*="price"]'
    );

    for (var i = 0; i < candidates.length; i++) {
      var el = candidates[i];
      if (el === compareEl) continue;
      if (el.tagName === 'S') continue;
      if (el.closest('s')) continue;
      if (el.classList.contains(BADGE_CLASS)) continue;
      if (el.classList.contains('bundly__bundle_original_price')) continue;
      if (parseMoney(el.textContent) != null) return el;
    }

    return null;
  }

  function calcDiscountLabel(compareEl, finalEl) {
    var compare = parseMoney(compareEl && compareEl.textContent);
    var final = parseMoney(finalEl && finalEl.textContent);

    if (compare == null || final == null || compare <= final) return '';

    var pct = Math.round(((compare - final) / compare) * 100);
    return pct > 0 ? '-' + pct + '%' : '';
  }

  function findMainMedia(block) {
    var selectors = [
      '.bundly__bundle_images',
      '.bundly__bundle_image',
      '.bundly__bundle-media',
      '.bundly__bundle-images',
      '.bundly__header .bundly__media',
      '.bundly__media'
    ];

    for (var i = 0; i < selectors.length; i++) {
      var el = block.querySelector(selectors[i]);
      if (el && !el.closest('.bundly__product-card, .bundly__component, [class*="component"]')) {
        return el;
      }
    }

    return null;
  }

  function removeBadges(block) {
    var badges = block.querySelectorAll('.' + BADGE_CLASS + '[' + BADGE_ATTR + ']');
    for (var i = 0; i < badges.length; i++) {
      badges[i].remove();
    }
  }

  function ensureHost(media) {
    if (!media.classList.contains(HOST_CLASS)) {
      media.classList.add(HOST_CLASS);
    }
    return media;
  }

  function renderBadge(block) {
    removeBadges(block);

    var fallback = readFallbackText();
    var compareEl = findComparePriceEl(block);
    var finalEl = findFinalPriceEl(block, compareEl);
    var label = calcDiscountLabel(compareEl, finalEl) || fallback;

    if (!label) return;

    var media = findMainMedia(block);
    if (!media) return;

    var host = ensureHost(media);
    var badge = document.createElement('span');
    badge.className = BADGE_CLASS;
    badge.setAttribute(BADGE_ATTR, 'true');
    badge.setAttribute('aria-hidden', 'true');
    badge.textContent = label;
    host.appendChild(badge);
  }

  function updateAll() {
    var blocks = findBlocks();
    for (var i = 0; i < blocks.length; i++) {
      renderBadge(blocks[i]);
    }
  }

  function scheduleUpdate() {
    for (var i = 0; i < RETRY_DELAYS.length; i++) {
      (function (delay) {
        setTimeout(updateAll, delay);
      })(RETRY_DELAYS[i]);
    }
  }

  function startObserver() {
    if (observerStarted || typeof MutationObserver === 'undefined') return;
    observerStarted = true;

    var observer = new MutationObserver(function () {
      scheduleUpdate();
    });

    function observeBlocks() {
      var blocks = findBlocks();
      for (var i = 0; i < blocks.length; i++) {
        observer.observe(blocks[i], { childList: true, subtree: true, characterData: true });
      }
    }

    observeBlocks();
    setTimeout(observeBlocks, 500);
    setTimeout(observeBlocks, 1500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scheduleUpdate();
      startObserver();
    });
  } else {
    scheduleUpdate();
    startObserver();
  }

  document.addEventListener('bundly:afterUpdateBlock', scheduleUpdate);
})();
